type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'ServicesCountry'
const nameSource = 'commercial/servicesCountries'
const namePageTitle = 'Países de serviço'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Países de serviço',
  to: '/commercial/servicesCountries',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/servicesCountries/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/servicesCountries/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/servicesCountries/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
